import { render, staticRenderFns } from "./RightOfWithdrawalModal.vue?vue&type=template&id=6d1ca395&scoped=true&"
import script from "./RightOfWithdrawalModal.vue?vue&type=script&lang=js&"
export * from "./RightOfWithdrawalModal.vue?vue&type=script&lang=js&"
import style0 from "./RightOfWithdrawalModal.vue?vue&type=style&index=0&id=6d1ca395&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ca395",
  null
  
)

export default component.exports